import * as React from "react";
const SvgHeartIcon = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M20.8 5.5c-.3-1.2-1-2.3-2.4-2.5-1.4-.3-3 .4-4.2 1.3a15 15 0 0 0-3.4 4.1l-.2.3h-.2l-.1-.2c-.2-1-.4-2-.8-3.1-.2-.7-.6-1.3-1-1.8l-.8-.8c-.9-.5-1.8-.3-2.4.4a3 3 0 0 0-.6 1.1c-.4 1-.4 2.2-.4 3.3C4.3 12.3 6 17.8 9.7 21c1.5 1.3 2.6 0 3.5-1.2 1.8-2.2 3.6-4.6 4.8-6.5 1.1-1.8 2.3-3.6 2.7-5.7.2-.7.2-1.4 0-2Z" style={{
    fill: "none",
    stroke: "#173b33",
    strokeMiterlimit: 10,
    strokeWidth: "1.15px"
  }} /></svg>;
export default SvgHeartIcon;